
import { Component, Vue } from 'vue-property-decorator'
import { getCategories, getCategory, getResourceList } from '@/api'
import { ICategorie } from '@/types/type'
import HeaderSearch from '@/components/componentWap/HeaderSearch.vue'
@Component({
    name: 'QuestionContents',
    components: {
        HeaderSearch
    }
})
export default class extends Vue {
    private loading = false
    private categorieList: ICategorie[] = []
    private changeState(index: number) {
        this.categorieList[index].isChecked = !this.categorieList[index].isChecked
        this.categorieList.splice(index, 1, this.categorieList[index])
    }
    private async setMenu(row: ICategorie, index1: number, index2: number) {
        this.loading = true
        if (!row.isChecked) {
            const res = await getResourceList(row.id || '').catch(() => this.loading = false)
            this.categorieList[index1].categoryList[index2].resourceList = res.data.list
        }
        this.categorieList[index1].categoryList[index2].isChecked = !row.isChecked
        this.loading = false
    }
    private goDetail(id: string) {
        this.$jump(`/Question/QuestionDetail?questionId=${id}`)
    }
    async created() {
        this.loading = true
        const res = await getCategories().finally(() => this.loading = false)
        this.categorieList = res.data.list
        const questionId = this.$route.query.questionId as string
        let categorieId = ''
        if (questionId) {
            const result = await getCategory(questionId).finally(() => this.loading = false)
            categorieId = result.data.categoryId
        } else if (this.categorieList && this.categorieList[0]) {
            categorieId = this.categorieList[0].categoryList[0].id || ''
        }
        this.categorieList = res.data.list.map((i: ICategorie) => {
            i.isChecked = false
            i.categoryList.forEach((j) => {
                j.isChecked = false
                if (j.id === categorieId) {
                    i.isChecked = true
                }
                
            })
            return i
        })
    }
}
